import React from 'react';
import { Checkbox, Radio } from 'antd';
import classNames from 'classnames';
import { FallbackMethod } from './use-fallback';
import { Tooltip } from 'components';
import { TEST_IDS } from '../../../test-ids';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

interface Props {
	onChangeFallback: (method: FallbackMethod) => void;
	onChangeEnabled: (isEnabled: boolean) => void;
	isEnabled: boolean;
	fallbackMethod: FallbackMethod;
	translations: Translations;
	readOnly?: boolean;
}

export interface Translations {
	fallbackHeader: string;
	fallbackTooltip: string;
	cheap: string;
	fast: string;
	priority: string;
}

const Fallback: React.FC<Props> = ({
	onChangeFallback,
	onChangeEnabled,
	isEnabled,
	fallbackMethod,
	translations,
	readOnly
}) => {
	const onChangeRadio = e => {
		onChangeFallback(e.target.value);
	};

	const onChangeCheckbox = e => {
		onChangeEnabled(e.target.checked);
	};

	return (
		<div className="fallback">
			<div className="fallback-enabled-checkbox" data-test-id={TEST_IDS.EnableFallbackCheckbox}>
				<Checkbox onChange={onChangeCheckbox} checked={isEnabled} disabled={readOnly} />
				<span className="fallback-enabled-checkbox-text">
					{translations.fallbackHeader}
					<Tooltip placement="top" title={translations.fallbackTooltip}>
						<span className="info-button">
							<BringgIcon iconName={BringgFontIcons.Help} />
						</span>
					</Tooltip>
				</span>
			</div>
			<div
				className={classNames('radio-wrapper', { disabled: !isEnabled || readOnly })}
				data-test-id={TEST_IDS.FallbackMethodsRadioInput}
			>
				<Radio.Group onChange={onChangeRadio} value={fallbackMethod} className="fallback-methods">
					{Object.values(FallbackMethod).map(method => (
						<Radio className="fallback-method" value={method} key={method}>
							{translations[method]}
						</Radio>
					))}
				</Radio.Group>
			</div>
		</div>
	);
};

export default Fallback;
